import { useParams } from 'react-router-dom';

import { PageHeader } from '../../../../components/PageHeader';
import { useIncomingOrder } from '../../models';
import { invariant, nullthrows } from '../../../../utils/invariant';
import { Button } from '../../../../components/button/Button';
import { DownloadSimpleIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { Breadcrumb } from 'components/Breadcrumb';
import { PageHeading } from 'components/PageHeading';
import { constructDownloadUrl } from 'src/app/document/models';
import { DelayedSpinner } from 'components/Spinner';

const IncomingOrderPage = () => {
  const { orderEmailId } = useParams<{ orderEmailId: string }>();
  invariant(orderEmailId);
  const { data, isLoading: isEmailLoading } = useIncomingOrder(orderEmailId);
  const [isDownloading] = useState(false);

  if (isEmailLoading) {
    return <DelayedSpinner size={8} />;
  }

  const email = nullthrows(data, 'IncomingOrder not found');

  return (
    <>
      <PageHeader title={email.subject} />

      <div>
        <PageHeading leftSide={<Breadcrumb currentItem="Binnengekomen Order" />} />
        <div className="px-4">
          <div>
            <div>Van: {email.from}</div>
            <div>Onderwerp: {email.subject}</div>
            {email.attachments.length > 0 && (
              <div className="my-2">
                <div className="font-medium mb-1">Bijlagen</div>
                <div className="flex flex-wrap gap-2">
                  {email.attachments.map((attachment) => {
                    const document = attachment.document;
                    return (
                      <Button
                        key={attachment.id}
                        iconLeft={<DownloadSimpleIcon className="button-icon" />}
                        isLoading={isDownloading}
                        onTrigger={() => {
                          // eslint-disable-next-line no-restricted-globals
                          window.open(
                            constructDownloadUrl({
                              documentId: document.id,
                              documentHash: document.hash,
                            }),
                            '_blank',
                          );
                        }}
                      >
                        {attachment.document.name}
                      </Button>
                    );
                  })}
                </div>
              </div>
            )}
            <div className="mt-4 whitespace-pre-line">
              <div className="font-medium">Inhoud</div>
              <div>{email.content.trim()}</div>
            </div>
          </div>

          <div className="my-4">
            <div className="heading-two mb-2">Prediction</div>
            <pre className="bg-neutral-subtle rounded p-2 w-full-content-padded overflow-y-auto">
              {email.aiPrediction ? JSON.stringify(JSON.parse(email.aiPrediction), null, 2) : 'Geen prediction'}
            </pre>
          </div>
        </div>
      </div>
    </>
  );
};

export default IncomingOrderPage;
